<template>
  <div class="main-container">
      <component :is="returnWiev"></component>
  </div>
</template>

<script>
import UnlimitedGolfSearchView from './views/UnlimitedGolfSearchView.vue'

export default {
    name : 'App',
    components: {
        UnlimitedGolfSearchView,
    },
    data() {
        return {
        }
    },
    computed: {
        isInstant() {
            return this.$store.state.instantQuote.isInstant;
        },
        returnWiev(){
            return this.$store.state.instantQuote.viewComponent;
        }
    },
    methods: {
        setInstant(val) {
            this.$store.commit('instantQuote/SET_INSTANT',val)
        }
    },
    mounted(){
        if(window.location.href.includes('vue-action=quoteId') || window.location.href.includes('/instant-quote')){
             this.$store.commit('instantQuote/SET_WIEV',"UnlimitedGolfSearchView" )
        }
    }
}
</script>


<style lang="scss">
@import url('https://fonts.googleapis.com/css2?family=Roboto:wght@300;400;500;700;900&display=swap');

.fusion-fullwidth .fullwidth-box .fusion-builder-row-3 .golf-redesign .hundred-percent-fullwidth .non-hundred-percent-height-scrolling .fusion-equal-height-columns{
    z-index: 1 !important;
}
.fusion-fullwidth .fullwidth-box .fusion-builder-row-4 .golf-redesign .hundred-percent-fullwidth .non-hundred-percent-height-scrolling .fusion-equal-height-columns{
    z-index: 1 !important;
}
* { font-family: "Roboto", sans-serif; }

button,
a {
    cursor: pointer;
    &:focus,
    &:active {
        outline: none !important;
    }
    text-decoration: none !important;
}

.main-container {
    max-width: 1620px;
    @media screen and (max-width: 1750px) {
      width: 100%;
    }
    margin: auto;
}
.link-container {
    border: 1px solid #CCCCCC;
    border-top-left-radius: 10px;
    border-top-right-radius: 10px;
    border-bottom: 4px solid #5E4896;
    padding: 30px 40px 0;
    @media screen and (max-width: 500px) {
        padding: 15px 20px 0;
    }
    .quote-links {
        display: flex;
        flex-wrap: wrap;
        .quote-link {
            height: 70px;
            width: 288px;
            color: #5E4896 !important;
            font-size: 24px;
            font-weight: 500;
            letter-spacing: 0;
            line-height: 18px;
            display: flex;
            justify-content: center;
            align-items: center;
            &.router-link-exact-active {
                border: 1px solid #5E4896 !important;
                border-bottom: 0;
                border-top-left-radius: 10px;
                border-top-right-radius: 10px;
                @media screen and (max-width: 500px) {
                    border-bottom: 1px solid #5E4896 !important;
                }
            }
            @media screen and (max-width: 1250px) {
                font-size: 18px;
            }
            @media screen and (max-width: 800px) {
                width: calc(50% - 10px);
            }
            @media screen and (max-width: 500px) {
                border-radius: 10px;
                width: 100%;
                border: 1px solid #ccc;
                margin: 10px;
            }
        }
    }
}
.content-container {
    border-top: 0;
    border: 1px solid #CCCCCC;
    border-bottom-left-radius: 10px;
    border-bottom-right-radius: 10px;
    @media screen and (max-width: 500px) {
        padding: 15px 5px;
    }
}

</style>
